import React from 'react';
import Hero from '../partials/Home/Hero';
import Features from '../partials/Home/Features';
import Testimonials from '../partials/Home/Testimonials';
import { CTASection } from '../partials/Home/CTASection';
import HowItsWorks from '../partials/Home/HowItsWorks';
import HomeFAQ from '../partials/Home/HomeFAQ';
import WhyChooseUs from '../partials/Home/WhyChooseUs';
import HomeUseCases from '../partials/Home/HomeUseCases';
// import Comparison from './Comperesion';
import Comparison from "../partials/Home/Comparison";
import NewsletterPopup from './NewsletterPopup';

const Home = () => {
  return (
    <div className="home-page">
      <NewsletterPopup />
      <Hero />
      <HowItsWorks />
      <WhyChooseUs />
      <Features />
      {/* <Testimonials /> */}
      <HomeUseCases />
      <Comparison />
      <CTASection />
      <HomeFAQ />
    </div>
  );
};

export default Home;